module.exports = __webpack_public_path__ + "img/collection-memoireRingsExclusive.254006d.jpg";